import {
  ControlField,
  Group,
  Grouping,
  PropertyTemplates,
  Section,
  Template,
} from '../../../contexts/MetadataContext';

import { v4 as uuidv4 } from 'uuid';

export interface PropertyTemplatesWithIds {
  [key: string]: TemplateWithIds;
}

export interface GroupWithId extends Omit<Group, 'sections'> {
  id: string;
  sections: SectionWithId[];
}

export interface GroupingWithId extends Grouping {
  id: string;
}

export interface SectionWithId extends Omit<Section, 'fields'> {
  id: string;
  fields: FieldWithId[];
}

export interface FieldWithId extends ControlField {
  id: string;
}

export interface TemplateWithIds
  extends Omit<Template, 'groupings' | 'groups'> {
  groups: GroupWithId[];
  groupings: GroupingWithId[];
  help?: Record<string, string>;
}

export const addIdsToTemplate = (
  template: PropertyTemplates,
): PropertyTemplatesWithIds => {
  const templatesWithIds: PropertyTemplatesWithIds = {};

  for (const [key, value] of Object.entries(template)) {
    templatesWithIds[key] = {
      ...value,
      groupings: (value.groupings || []).map((grouping: Grouping) => {
        return {
          ...grouping,
          id: uuidv4(),
        };
      }),
      groups: value.groups.map(
        (group: Group): GroupWithId => ({
          ...group,
          id: uuidv4(),
          sections: group.sections.map(
            (section: Section): SectionWithId => ({
              ...section,
              id: uuidv4(),
              fields: section.fields.map(
                (field: ControlField): FieldWithId => ({
                  ...field,
                  id: uuidv4(),
                }),
              ),
            }),
          ),
        }),
      ),
    };
  }

  return templatesWithIds;
};
